import React, { useEffect, useState } from "react";
import s from './paperSets.module.css';
import { useNavigate } from "react-router-dom";
import {getData, postData} from '../middleware/apiMiddleware';
import {GreenButton, BlueButton} from '../components/MyButton';
import {Form} from 'react-bootstrap';


export default function PaperSets() {
	const navigate = useNavigate();
	
	const [paperSets, setPaperSets] = useState([]);
	
	const [enableCreatePaper, setEnableCreatePaper] = useState(false);
	const [createType, setCreateType] = useState("wordFillIn");
	const [paperTitle, setPaperTitle] = useState("");
	const [paperSummary, setPaperSummary] = useState("");
	
	const changeCreateType = () => {
		if (createType == 'wordsExplanation') {
			setCreateType('grammarDiagnostic');
		} else if (createType == 'grammarDiagnostic') {
			setCreateType('wordFillIn');
		} else {
			setCreateType('wordsExplanation');
		}
	}
	
	const fetchData = () => {		
		getData('paperSetApi/list', navigate)
		.then(res => {
				setPaperSets(res.data);
			}
		);
	}
	
	
	useEffect(() => {
		fetchData();
	}, []);
	
	const [cSentence, setCSentence] = useState("");
	const [cProcess, setCProcess] = useState([]);
	const [cWEObjects, setWEObjects] = useState([]);
	
	
	const processCreation = async () => {
		if (createType == 'wordsExplanation') {
		} else if (createType == 'wordFillIn') {
			processCreateWordFillIn();
		} else {
		}
		
		
		/*let obj = {
			'data' : cSentence,
		}
		
		let res = await postData("paperSetApi/processWordsExplanation", obj, navigate); 
		setWEObjects(res.data);*/
	}
	const processCreateWordFillIn = async () => {
		let cuts = cSentence.split(/[#@]/);
		
		const result = [];

		
		let obj = {
			'qcType':32,
			'prefix':null,
			'answer':null,
			'actualWord':null,
			'actualWordId':null,
			'suffix':null,
			'optionStr':"",
			'options':[],
		}
		
		let prefix = cuts[0];
		// loop through the split values and delimiters
		for (let i = 0; i < cuts.length - 1; i++) {
			// determine the delimiter by looking at the character after the split value
			const delimiter = cSentence.charAt(cSentence.indexOf(cuts[i]) + cuts[i].length);
			
			if (i % 2 == 0) {
				if (obj.prefix == null) {
					obj.prefix = prefix;
				} else {
					let index = Math.min(cuts[i].indexOf("."), cuts[i].indexOf(","));
					
					if (cuts[i].indexOf(".") == -1) {
						index = cuts[i].indexOf(",");
					} else {
						index = cuts[i].indexOf(".");
					}
					
					// split the string into two substrings at the index
					obj.suffix = cuts[i].substring(0, index + 1);
					prefix = cuts[i].substring(index + 2);
					result.push(obj);
					
					obj = {
						'prefix':prefix,
						'qcType':32,
						'answer':null,
						'actualWord':null,
						'actualWordId':null,
						'suffix':null,
						'optionStr':"",
						'options':[],
					}
				}
			} else {
				
				obj.qcType = (delimiter=='#') ? 32 : 34;
				obj.answer = cuts[i];
				obj.actualWord = cuts[i];
			}
		}
		setCProcess(result);
		
	}
	
	const processCheckWord = async () => {
		let words = [];
		
		cProcess.map(v=> {
			words.push(v.actualWord);
			
			v.options.map(o=>{
				words.push(o.actualWord);
				
			})
		})
		
		let obj = {
			'words' : words,
		}
		
		let res = await postData("wordApi/checkWordIds", obj, navigate); 
		
		let wordIdMap = res.data;
		
		cProcess.forEach(v=>{
			if (wordIdMap[v.actualWord]) {
				v.actualWordId = wordIdMap[v.actualWord];
			}
			
			if (v.qcType == 32) {
				v.options.forEach(o=>{
					if (wordIdMap[o.actualWord]) {
						o.actualWordId = wordIdMap[o.actualWord];
					}
					
				})
			}
		})
		
		setCProcess([...cProcess]);
	}
	
	const createWordPaper = async () => {
		
		let obj = {
			'title':paperTitle,
			'summary':paperSummary,
			'type':"wordFillIn",
			'questionData' : cProcess,
		}
		
		let res = await postData("paperSetApi/createWordFillInPaper", obj, navigate); 
		
	}
	
	
	return (
		<div className={s.container}>
			<div className={s.createButton}>
				<GreenButton isEnabled={true} clickedAction={()=>{setEnableCreatePaper(p=>!p)}} bText={"create paper"} />
			</div>
			
			{
				(enableCreatePaper) && (<div className={s.wordsExplanationHolder_div}>
					<div>Create <BlueButton isEnabled={true} clickedAction={()=>{changeCreateType()}} bText={createType} /></div>
					
					title: <input className={s.wordFillIn_prefix_div} value={paperTitle} onChange={(e) => {setPaperTitle(e.target.value);}}/>
					summary: <input className={s.wordFillIn_prefix_div} value={paperSummary} onChange={(e) => {setPaperSummary(e.target.value);}}/>
					<textarea className={s.textAreaAuto} value={cSentence} rows={10} wrap='off' onChange={(e) => {
						setCSentence(e.target.value);
					}}/>
					<GreenButton isEnabled={true} clickedAction={()=>processCreation()} bText={"process"} />
					{
						(cProcess.length >0) && (<div>
							{
								(createType == 'wordFillIn') && (<div>
									{
										cProcess.map((v, indexV) => (<div className={(indexV % 2 == 0) ? s.wordFillIn_isShared : ""}>
											<div className={s.wordFillIn_rowHolder_div}>
												<Form.Select className={s.createPaper_row_qtnType_div} value={v.qcType}  onChange={(e) => {
														cProcess[indexV].qcType = e.target.value;
														setCProcess([...cProcess]);}
													} >
													<option value="30">Q30 - MC(wks)</option>
													<option value="31">Q31 - Word Explanation</option>
													<option value="32">Q32 - Fill-IN(Word)</option>
													<option value="33">Q33 - Fill-IN(Wks)</option>
													<option value="34">Q34 - MC in Article(word)</option>
												</Form.Select>
												
												<input className={s.wordFillIn_prefix_div} value={v.prefix} onChange={(e) => {
													cProcess[indexV].prefix = e.target.value;												
													setCProcess([...cProcess]);
												}}/>
												<input className={s.wordFillIn_answer_div} value={v.answer} onChange={(e) => {
													cProcess[indexV].answer = e.target.value;												
													setCProcess([...cProcess]);
												}}/>
												<input className={s.wordFillIn_answer_div} value={v.actualWord} onChange={(e) => {
													cProcess[indexV].actualWord = e.target.value;												
													setCProcess([...cProcess]);
												}}/>
												<div className={s.wordFillIn_actualWordId_div} >{v.actualWordId}</div>
												<input className={s.wordFillIn_suffix_div} value={v.suffix} onChange={(e) => {
													cProcess[indexV].suffix = e.target.value;												
													setCProcess([...cProcess]);
												}}/>
											</div>
											{(v.qcType == 34) && (<div className={s.wordFillIn_break_holder_div}>
												<div>options</div>
												<input className={s.wordFillIn_break_div} value={v.optionStr} onChange={(e) => {
													cProcess[indexV].optionStr = e.target.value;
													setCProcess([...cProcess]);
												}}/>
												<GreenButton isEnabled={true} clickedAction={()=>{
													cProcess[indexV].options = v.optionStr.split("/").map(oo => ({word:oo}));
													setCProcess([...cProcess]);
												}} bText={"break"} />
													{
														(v.options.length>0) && (<div>
														{
															v.options.map((o, indexO) => (<div className={s.wordFillIn_option_holder_div}>
																<input className={s.wordFillIn_option_div} value={o.word} onChange={(e) => {
																	cProcess[indexV].options[indexO].word = e.target.value;
																	setCProcess([...cProcess]);
																}}/>
																{
																	(indexO == 0) && (<div style={{color:"red"}}>answer</div>)
																}
																<div>{o.actualWordId}</div>
															</div>))
														}
														</div>)
													}
											</div>)}
										</div>))
									}
									
									<GreenButton isEnabled={true} clickedAction={()=>processCheckWord()} bText={"check word"} />
									<GreenButton isEnabled={true} clickedAction={()=>createWordPaper()} bText={"run create paper"} />
								</div>)
							}
						</div>)
					}
					
					
				</div>)
			}
			
			
			
			
			{
				(cWEObjects.length>0) && (<div></div>)
			}
			<div className={s.paperSetListHolder}>
				<div className={s.paperSetHolder_div}>
					<div style={{fontWeight:"bold", flex:"1",flexBasis:"5%"}}>id</div>
					<div style={{fontWeight:"bold", flex:"1",flexBasis:"45%"}}>name</div>
					<div style={{fontWeight:"bold", flex:"1",flexBasis:"35%"}}>summary</div>
					<div style={{fontWeight:"bold", flex:"1",flexBasis:"5%"}}>SO</div>
					<div style={{fontWeight:"bold", flex:"1",flexBasis:"10%"}}></div>
				</div>
			
			{
				paperSets.map(v=> (<div className={s.paperSetHolder_div}>
					<div style={{flex:"1",flexBasis:"5%"}}>{v.id}</div>
					<div style={{flex:"1",flexBasis:"45%"}}>{v.name}</div>
					<div style={{flex:"1",flexBasis:"35%"}}>{v.summary}</div>
					<div style={{flex:"1",flexBasis:"5%"}}>{v.isSharedOption}</div>
					<div style={{flex:"1",flexBasis:"10%"}}>
						
					
					</div>
				</div>))
			}
			</div>
			
		</div>
	);
}
